import { Avatar, ButtonBase, Tooltip } from '@mui/material';

import * as voiceLib from 'entities/voice/lib';

import { Voices } from 'shared/api';
import { useFileUrl } from 'shared/lib';

type Props = {
  voice: Voices;
  onOpen: (voice: Voices) => void;
};

const SIZE = 36;

/** Аватар в ячейке Name. Пока файл грузится или его нет — первая буква имени. */
export const VoiceAvatar = ({ voice, onOpen }: Props) => {
  const path = voiceLib.getAvatarPath(voice.avatar);
  const src = useFileUrl(path);
  const initial = voice.name?.[0]?.toUpperCase() ?? '';

  const avatar = (
    <Avatar src={src || undefined} alt={voice.name} sx={{ width: SIZE, height: SIZE, fontSize: 16 }}>
      {initial}
    </Avatar>
  );

  if (!src) return avatar;

  return (
    <Tooltip title="View photo">
      <ButtonBase
        aria-label={`View photo of ${voice.name}`}
        onClick={(event) => {
          event.stopPropagation();
          onOpen(voice);
        }}
        sx={{
          borderRadius: '50%',
          transition: 'transform 0.15s, box-shadow 0.15s',
          '&:hover': { transform: 'scale(1.08)', boxShadow: 3 },
          '&.Mui-focusVisible': { boxShadow: 3 },
        }}
      >
        {avatar}
      </ButtonBase>
    </Tooltip>
  );
};
